var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiListItemText from '@material-ui/core/ListItemText';
/**
 * Kareo wrapped component of the Material-UI ListItemText. The prop API has been limited to props defined in ListItemTextProps.
 *
 * Material-UI ListItemText: [Docs](https://v4.mui.com/components/lists/), [API](https://v4.mui.com/api/list-item-text/)
 *
 * @storybook: [List](http://design.kareoprod.ent/design-system/?path=/story/components-data-display-list--simple-list-storybook)
 */
var ListItemText = React.forwardRef(function (props, ref) {
    return React.createElement(MuiListItemText, __assign({}, props, { ref: ref }));
});
ListItemText.defaultProps = {};
ListItemText.displayName = 'KareoListItemText';
export default ListItemText;
